var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.248,
    height: 9.571,
    viewBox: "0 0 13.248 9.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_FILL0_wght600_GRAD0_opsz48",
    d: "M12.389,21.871a.774.774,0,0,1-.308-.062.853.853,0,0,1-.267-.185L8.1,17.907a.843.843,0,0,1,0-1.191.818.818,0,0,1,1.171,0l3.122,3.122L19.7,12.546a.734.734,0,0,1,.565-.246.8.8,0,0,1,.585.246.812.812,0,0,1,.246.6.746.746,0,0,1-.246.575l-7.887,7.908a.853.853,0,0,1-.267.185.774.774,0,0,1-.308.062Z",
    transform: "translate(-7.85 -12.3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d60e3b194d34677632beadcf63ecfd24.svg";
export { ForwardRef as ReactComponent };